import type { IAuditoriaEventoClonar } from "@/api/space/dtos/authenticator.dto";
import { rotuloContagem } from "../auditoria.utils";
import CabecalhoEvento from "./CabecalhoEvento";
import ChipResumo from "./ChipResumo";

/** Card de evento "Clonagem de grupo": destino + contagens clonadas. */
export default function CardEventoClonar({ evento }: { readonly evento: IAuditoriaEventoClonar }) {
	return (
		<div className="rounded-md border border-border/60 bg-card shadow-sm">
			<div className="flex w-full items-center gap-3 p-3">
				<CabecalhoEvento evento={evento} />
			</div>

			<div className="flex flex-col gap-2 px-3 pb-3 pl-15">
				<div className="flex items-center gap-1.5 text-sm text-foreground">
					<span className="text-muted-foreground">Clonado para</span>
					<span className="font-bold">{evento.destino.descricao}</span>
					<span className="text-sm text-muted-foreground">| Grupo: {evento.destino.id}</span>
				</div>
				<div className="flex flex-wrap gap-1.5">
					<ChipResumo tom="info">
						{rotuloContagem(evento.resumo.permissoes_clonadas, "permissão clonada", "permissões clonadas")}
					</ChipResumo>
					<ChipResumo tom="info">
						{rotuloContagem(evento.resumo.recursos_clonados, "recurso clonado", "recursos clonados")}
					</ChipResumo>
				</div>
			</div>
		</div>
	);
}
